import { useSelector } from 'react-redux';
import { getNotificationEntityIds } from '../../store/selectors/user';

export default (entityField, entity) => {
  // Check if we're subscribed to this entity notifications
  const notifyingEntityIds = useSelector(state => getNotificationEntityIds(state, { entityField }));
  return notifyingEntityIds.includes(entity.id);
};
